module.exports = __webpack_public_path__ + "img/alile.d0bf14b0.png";